import { render } from "./ProfileCertifications.vue?vue&type=template&id=30da9c42&scoped=true&ts=true"
import script from "./ProfileCertifications.vue?vue&type=script&lang=ts"
export * from "./ProfileCertifications.vue?vue&type=script&lang=ts"

import "./ProfileCertifications.vue?vue&type=style&index=0&id=30da9c42&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30da9c42"]])

export default __exports__